{
  "Sign In - EventLive": "Inloggen - EventLive",
  "Forgot Password - EventLive": "Wachtwoord vergeten - EventLive",
  "Password Restore Link Sent - EventLive": "Herstellink verstuurd - EventLive",
  "Event": "Evenement",
  "Event Details": "Evenementdetails",
  "Details": "Details",
  "How to Go Live": "Zo ga je live",
  "Multi-Camera": "Multicamera",
  "Add a room": "Zaal toevoegen",
  "Guest List": "Gastenlijst",
  "Import Guests": "Gasten importeren",
  "Add a Guest": "Gast toevoegen",
  "Event Analytics": "Evenementstatistieken",
  "Purchase Successful": "Aankoop gelukt",
  "Test EventLive": "EventLive testen",
  "Schedule Event": "Evenement plannen",
  "Download everything": "Alles downloaden",
  "Update Email": "E-mailadres wijzigen",
  "Help Us Grow": "Help ons groeien",
  "Set a New Password - EventLive": "Nieuw wachtwoord instellen - EventLive",
  "Are you sure?": "Weet je het zeker?",
  "Could not load data. Please check your internet connection. Ensure the timezone, date and time on your device are correct.": "De gegevens konden niet worden geladen. Controleer je internetverbinding. Zorg dat de tijdzone, de datum en de tijd op je apparaat kloppen.",
  "Couldn't save your profile": "Je profiel kon niet worden opgeslagen",
  "Link required": "Link is verplicht",
  "Overview": "Overzicht",
  "{days}-Day Event: {start} – {end}": "{days}-daags evenement: {start} – {end}",
  "Close event": "Evenement sluiten",
  "This sign-in link has expired": "Deze inloglink is verlopen",
  "Couldn't sign you in from this link": "We konden je niet inloggen met deze link",
  "Please sign in to continue.": "Log in om verder te gaan.",
  "Couldn't save your changes": "Je wijzigingen konden niet worden opgeslagen",
  "TEST": "TEST",
  "Download EventLive for Mac": "EventLive voor Mac downloaden",
  "Download for": "Downloaden voor",
  "People": "Personen",
  "Team invite - EventLive": "Teamuitnodiging - EventLive"
}
